export const GET_ASSET_MUTE_SETTINGS = 'muteAsset/GET_ASSET_MUTE_SETTINGS';
export const SET_UPDATE_MUTE_SETTINGS_LOADING = 'muteAsset/SET_UPDATE_MUTE_SETTINGS_LOADING';
export const CLEAR_STORE = 'muteAsset/CLEAR_STORE';
